
    const _each = require("lodash/each");
    const _times = require("lodash/times");
    const _escape = require("lodash/escape");
    const _throttle = require("lodash/throttle");

    const _ = {
        each: _each,
        times: _times,
        escape: _escape,
        throttle: _throttle,
    };

    module.exports = function(context) {
var __t, __p = '', __e = _.escape;
__p += '<div class="fullscreen-overlay__view-similar slide-control__element"><div class="fullscreen-overlay-inner"><h3 class="mb15">Sold Out</h3><a href="#relatedproducts" class="btn btn-primary btn--full-width">see similar items</a><div class="fullscreen-overlay__or-block"><span>or</span></div><div>See New In from <em><a href="' +
__e( context.designerLink ) +
'">' +
__e( context.designer ) +
'</a></em></div></div></div>';
return __p
};
    